import classnames from "classnames";
import * as React from "react";
import styled from "styled-components";

interface ICountdownClockProps {
  /**
   * remaining time in milliseconds
   */
  remaining: number,

  hidden?: boolean,

  color?: string
  className?: string
}

class CountdownClock extends React.Component<ICountdownClockProps> {

  private RADIUS: number = 40;
  private msInHour: number = 60000 * 60;

  public render() {
    if (this.props.hidden) {
      return '';
    }

    const value = this.props.remaining / this.msInHour;

    const dashArray = 2 * Math.PI * this.RADIUS;
    const dashOffset = -1 * dashArray * (1 - value);

    return (
        <svg viewBox="0 0, 100, 100" shapeRendering="geometricPrecision" className={classnames(this.props.className, this.props.color)}>
          <circle className={"remaining"} r={this.RADIUS} cx={"50%"} cy={"50%"} strokeDasharray={dashArray} strokeDashoffset={dashOffset} strokeLinecap={"round"}/>)
          <circle className={"background"} r={this.RADIUS} cx={"50%"} cy={"50%"} />
        </svg>
    );
  }
}

export default styled(CountdownClock)`
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;

    transform: rotate(-90deg);
    
    circle {
      fill: none;
      stroke-width: 2.5px;
    }

    .background {     
      stroke: rgba(255,255,255,0.125);
    }

    &.red .remaining {
      stroke: red;     
    }

    &.green .remaining {
      stroke: green;     
    }

    &.blue .remaining {
      stroke: blue;
    }
`;



// WEBPACK FOOTER //
// ./src/components/CountdownClock.tsx